import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            hasError: false, 
            error: null,
            errorInfo: null,
            errorStack: null
        };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI
        return { 
            hasError: true,
            errorStack: error.stack || error.toString()
        };
    }

    componentDidCatch(error, errorInfo) {
        // Log error details
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        
        // Update state with error details
        this.setState({
            error: error.toString(),
            errorInfo: errorInfo.componentStack
        });
    }

    render() {
        if (this.state.hasError) {
            // Fallback UI with error details
            return (
                <div style={{
                    padding: '20px',
                    backgroundColor: '#f8f8f8',
                    minHeight: '100vh',
                    fontFamily: 'Arial, sans-serif'
                }}>
                    <h1 style={{ color: '#d32f2f' }}>Something went wrong!</h1>
                    
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '15px',
                        borderRadius: '5px',
                        marginBottom: '20px',
                        border: '1px solid #ddd'
                    }}>
                        <h3>Error Message:</h3>
                        <pre style={{ 
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-word',
                            fontSize: '12px'
                        }}>
                            {this.state.error || 'Unknown error'}
                        </pre>
                    </div>

                    {this.state.errorStack && (
                        <div style={{
                            backgroundColor: '#fff',
                            padding: '15px',
                            borderRadius: '5px',
                            marginBottom: '20px',
                            border: '1px solid #ddd'
                        }}>
                            <h3>Stack Trace:</h3>
                            <pre style={{ 
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                fontSize: '10px',
                                maxHeight: '200px',
                                overflow: 'auto'
                            }}>
                                {this.state.errorStack}
                            </pre>
                        </div>
                    )}

                    {this.state.errorInfo && (
                        <div style={{
                            backgroundColor: '#fff',
                            padding: '15px',
                            borderRadius: '5px',
                            marginBottom: '20px',
                            border: '1px solid #ddd'
                        }}>
                            <h3>Component Stack:</h3>
                            <pre style={{ 
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                fontSize: '10px',
                                maxHeight: '200px',
                                overflow: 'auto'
                            }}>
                                {this.state.errorInfo}
                            </pre>
                        </div>
                    )}

                    <div style={{
                        backgroundColor: '#fff',
                        padding: '15px',
                        borderRadius: '5px',
                        border: '1px solid #ddd'
                    }}>
                        <h3>Debug Info:</h3>
                        <p><strong>User Agent:</strong> {navigator.userAgent}</p>
                        <p><strong>URL:</strong> {window.location.href}</p>
                        <p><strong>Time:</strong> {new Date().toISOString()}</p>
                    </div>

                    <button 
                        onClick={() => window.location.reload()}
                        style={{
                            marginTop: '20px',
                            padding: '10px 20px',
                            backgroundColor: '#1976d2',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px'
                        }}
                    >
                        Reload Page
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;